// extracted by mini-css-extract-plugin
module.exports = {"MysteryBoxModal":"MysteryBoxModal_MysteryBoxModal__NWVyd"};